export const isLoadingByKey = (jsonData = {}, ...keys) => {
  // Provide a default empty object in case jsonData is undefined or null
  const { loading } = jsonData;
  for (const key of keys) {
    if (loading?.hasOwnProperty(key) && loading[key]) {
      return true; // Return true if loading is true for any key
    }
  }
  return false; // Return false if loading is false for all keys or keys are not present
};
